export default function AutoRedirect() {
  window.onload = function () {
    window.location.href = 'https://t.me/veretnica_999';
  };
}
